import React from "react";

export const FollowUpBadge = ({ date, testid }) => {
  if (!date) return null;
  const today = new Date().toISOString().slice(0, 10);
  let cls = "bg-slate-100 text-slate-600";
  let label = date;
  if (date < today) { cls = "bg-rose-100 text-rose-700"; label = `Overdue · ${date}`; }
  else if (date === today) { cls = "bg-amber-100 text-amber-700"; label = "Due today"; }
  else { cls = "bg-slate-100 text-slate-600"; label = date; }
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-[11px] font-semibold ${cls}`}>
      {label}
    </span>
  );
};
